export class AppConstants {
    public static blogPosts(): string {
        return '/blog_posts';
    }

    public static blogLayoutPosts(): string {
        return '/blog_layout';
    }

    public static blogAuthorsURL(): string {
        return '/blog_authors';
    }

    public static blogTagsURL(): string {
        return '/blog_tags';
    }

    public static blogRollsURL(): string {
        return '/blog_rolls';
    }

    public static blogLabels(): string {
        return '/blog_labels';
    }
}
